import React, {
   createContext,
   PropsWithChildren,
   useContext,
   useRef
} from 'react'

import DynamicFeatureTogglesStore from '../../stores/DynamicFeatureTogglesStore/DynamicFeatureTogglesStore'

const DynamicFeatureTogglesStoreContext = createContext<DynamicFeatureTogglesStore | null>(
   null
)

interface Props extends PropsWithChildren {}

export const DynamicFeatureTogglesStoreProvider = (props: Props) => {
   const { children } = props
   const dynamicFeatureTogglesStoreRef = useRef(
      DynamicFeatureTogglesStore.create()
   )
   return (
      <DynamicFeatureTogglesStoreContext.Provider
         value={dynamicFeatureTogglesStoreRef.current}
      >
         {children}
      </DynamicFeatureTogglesStoreContext.Provider>
   )
}

const useDynamicFeatureTogglesStore = () => {
   const dynamicFeatureTogglesStore = useContext(
      DynamicFeatureTogglesStoreContext
   )
   if (!dynamicFeatureTogglesStore) {
      throw new Error(
         'Expected to be wrapped in DynamicFeatureTogglesStoreProvider'
      )
   }
   return dynamicFeatureTogglesStore
}

export default useDynamicFeatureTogglesStore
